module.exports = __webpack_public_path__ + "img/produkterdkERST_Logo_DARK.d110f8ad.svg";